export const leadsStatus: {
  id: number;
  label: string;
  key: string;
  btnClass: string;
  class: string;
}[] = [
  {
    id: 0,
    label: 'Process initiated',
    key: 'STATUSES.LEADS.PROCESS_INITIATED',
    btnClass: 'btn-light',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 1,
    label: 'Contacted',
    key: 'STATUSES.LEADS.CONTACTED',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-phone v-text-warning'
  },
  {
    id: 2,
    label: 'Completed',
    key: 'STATUSES.LEADS.COMPLETED',
    btnClass: 'v-btn-success',
    class: 'lnr lnr-check v-text-success'
  }
];
